import { render } from "./Ibayar.vue?vue&type=template&id=5a1d3439"
import script from "./Ibayar.vue?vue&type=script&lang=js"
export * from "./Ibayar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__